import { FilterCreatedByChip } from "./FilterCreatedByChip";
import { FilterDateChip } from "./FilterDateChip";
import { FilterStatusChip } from "./FilterStatusChip";
import { FilterTypeChip } from "./FilterTypeChip";

export const FilterSection: React.FC = () => {
  return (
    <section style={{ display: "flex", flex: 1, alignItems: "center", overflow: "auto" }}>
      <FilterCreatedByChip />
      <FilterTypeChip />
      <FilterStatusChip />
      <FilterDateChip />
    </section>
  );
};
